var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SubNav',{attrs:{"active":2}}),_c('div',{staticClass:"profile-img"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})]),_c('div',{staticClass:"profile-content",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }